import { JWT_TOKEN_HEADER_KEY } from "../../../../../../Common/modules/DataProvider/constants/DataProvider.constants";
import { customRequest } from "../../../../../../Common/modules/DataProvider/utils/DataProvider.utils";
import { IOnboarding } from "../../../IOnboarding";
import { fetch_customer_details_api } from "../constants/Customer.apis";

export const fetchCustomerDetails = (accessToken?: string) => {
  return customRequest<IOnboarding.IFetchCustomerDetailsResponse>({
    endpoint: fetch_customer_details_api,
    ...(accessToken
      ? {
          headers: {
            [JWT_TOKEN_HEADER_KEY]: accessToken,
          },
        }
      : {}),
  });
};
